import { formConfig } from "../form/formConfig";

/**
 * Maps form values to backend parameter format based on formConfig
 * @param {Object} formValues - The form values from react-hook-form
 * @returns {Object} - Backend formatted parameters
 */
export const mapFormToBackend = (formValues) => {
  const backendParams = {};

  formConfig.forEach((config) => {
    const formValue = formValues[config.name];

    // Skip colorPicker and materialPicker - they don't affect geometry
    if (config.type === 'colorPicker' || config.type === 'materialPicker') {
      return;
    }

    // Handle dimensionPicker type with nested fields
    if (config.type === 'dimensionPicker' && config.fields) {
      Object.entries(config.fields).forEach(([fieldKey, fieldConfig]) => {
        if (fieldConfig.backendKey && formValue?.[fieldKey]) {
          backendParams[fieldConfig.backendKey] = formValue[fieldKey];
        }
      });
    }
    // Handle singleDimensionPicker type
    else if (config.type === 'singleDimensionPicker' && config.backendKey && formValue !== undefined && formValue !== '') {
      backendParams[config.backendKey] = formValue;
    }
    // Handle other types with backendKey
    else if (config.backendKey && formValue !== undefined && formValue !== '') {
      backendParams[config.backendKey] = formValue;
    }
  });

  return backendParams;
};
